import React, { Component } from "react";
import { Route, Router } from "react-router-dom";
import { connect } from "react-redux";
import * as actions from "./actions";
import AboutPage from "./pages/AboutPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import HomePage from "./pages/HomePage";
import Profile from "./components/Profile/Profile";
import Project from "./components/Projects/Project";
import Projects from "./components/Projects/Projects";
import Charity from "./components/Charities/Charity";
import Callback from "./components/Callback/Callback";
import Auth from "./components/Auth/Auth";
import history from "./utils/history";

const auth = new Auth();

const handleAuthentication = (nextState, replace) => {
  if (/access_token|id_token|error/.test(nextState.location.hash)) {
    auth.handleAuthentication();
  }
};

class MainRoutes extends Component {
  render() {
    return (
      <Router history={history} component={HomePage}>
        <div className="page-root">
          <Route
            exact
            path="/"
            render={props => <HomePage auth={auth} {...props} />}
          />
          <Route
            path="/about"
            render={props => <AboutPage auth={auth} {...props} />}
          />
          <Route
            path="/terms"
            render={props => <TermsPage auth={auth} {...props} />}
          />
          <Route
            path="/privacy"
            render={props => <PrivacyPage auth={auth} {...props} />}
          />
          <Route
            path="/profile"
            render={props => <Profile auth={auth} {...props} />}
          />
          <Route
            exact
            path="/projects"
            render={props => <Projects auth={auth} {...props} />}
          />
          <Route
            path="/projects/:id"
            render={props => <Project auth={auth} {...props} />}
          />
          <Route
            path="/charities/:id"
            render={props => <Charity auth={auth} {...props} />}
          />
          <Route
            path="/callback"
            render={props => {
              handleAuthentication(props);
              return <Callback {...props} />;
            }}
          />
        </div>
      </Router>
    );
  }
}

export default connect(
  null,
  actions
)(MainRoutes);



// WEBPACK FOOTER //
// ./src/routes.js